import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Repository } from '../../../services/repository'
import { ToolDataService } from '../../../services/tooldata.service'
import { DialogComponent, ButtonPropsModel } from '@syncfusion/ej2-angular-popups';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';

import { TranslateService } from '@ngx-translate/core';

import {
  RichTextEditorComponent, FileManagerSettingsModel, QuickToolbarSettingsModel,
  ToolbarService, LinkService, ImageService, HtmlEditorService
} from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';

import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';



import { loadCldr, L10n } from '@syncfusion/ej2-base';

declare let require1: Function;
loadCldr(
  require('../../../../../node_modules/cldr-data/supplemental/numberingSystems.json'),
  require('../../../../../node_modules/cldr-data/main/vi/ca-gregorian.json'),
  require('../../../../../node_modules/cldr-data/main/vi/currencies.json'),
  require('../../../../../node_modules/cldr-data/main/vi/numbers.json'),
  require('../../../../../node_modules/cldr-data/main/vi/timeZoneNames.json')
);

const swal = require('sweetalert');
L10n.load({
  "vi": {
    "schedule": {
      "day": "Ngày",
      "week": "Tuần",
      "workWeek": "Work Week",
      "month": "Month",
      "year": "Year",
      "agenda": "Agenda",
      "weekAgenda": "Week Agenda",
      "workWeekAgenda": "Work Week Agenda",
      "monthAgenda": "Month Agenda",
      "today": "Today",
      "noEvents": "No events",
      "emptyContainer": "There are no events scheduled on this day.",
      "allDay": "All day",
      "start": "Start",
      "end": "End",
      "more": "more",
      "close": "Close",
      "cancel": "Cancel",
      "noTitle": "(No Title)",
      "delete": "Delete",
      "deleteEvent": "This Event",
      "deleteMultipleEvent": "Delete Multiple Events",
      "selectedItems": "Items selected",
      "deleteSeries": "Entire Series",
      "edit": "Edit",
      "editSeries": "Entire Series",
      "editEvent": "This Event",
      "createEvent": "Create",
      "subject": "Subject",
      "addTitle": "Add title",
      "moreDetails": "More Details",
      "save": "Save",
      "editContent": "How would you like to change the appointment in the series?",
      "deleteContent": "Are you sure you want to delete this event?",
      "deleteMultipleContent": "Are you sure you want to delete the selected events?",
      "newEvent": "New Event",
      "title": "Title",
      "location": "Location",
      "description": "Description",
      "timezone": "Timezone",
      "startTimezone": "Start Timezone",
      "endTimezone": "End Timezone",
      "repeat": "Repeat",
      "saveButton": "Save",
      "cancelButton": "Cancel",
      "deleteButton": "Delete",
      "recurrence": "Recurrence",
      "wrongPattern": "The recurrence pattern is not valid.",
      "seriesChangeAlert": "Do you want to cancel the changes made to specific instances of this series and match it to the whole series again?",
      "createError": "The duration of the event must be shorter than how frequently it occurs. Shorten the duration, or change the recurrence pattern in the recurrence event editor.",
      "sameDayAlert": "Two occurrences of the same event cannot occur on the same day.",
      "editRecurrence": "Edit Recurrence",
      "repeats": "Repeats",
      "alert": "Alert",
      "startEndError": "The selected end date occurs before the start date.",
      "invalidDateError": "The entered date value is invalid.",
      "blockAlert": "Events cannot be scheduled within the blocked time range.",
      "ok": "Ok",
      "yes": "Yes",
      "no": "No",
      "occurrence": "Occurrence",
      "series": "Series",
      "previous": "Previous",
      "next": "Next",
      "timelineDay": "Timeline Day",
      "timelineWeek": "Timeline Week",
      "timelineWorkWeek": "Timeline Work Week",
      "timelineMonth": "Timeline Month",
      "timelineYear": "Timeline Year",
      "editFollowingEvent": "Following Events",
      "deleteTitle": "Delete Event",
      "editTitle": "Edit Event",
      "beginFrom": "Begin From",
      "endAt": "End At",
      "expandAllDaySection": "Expand-all-day-section",
      "collapseAllDaySection": "Collapse-all-day-section"
    },
    "recurrenceeditor": {
      "none": "None",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "month": "Month",
      "yearly": "Yearly",
      "never": "Never",
      "until": "Until",
      "count": "Count",
      "first": "First",
      "second": "Second",
      "third": "Third",
      "fourth": "Fourth",
      "last": "Last",
      "repeat": "Repeat",
      "repeatEvery": "Repeat every",
      "on": "Repeat On",
      "end": "End",
      "onDay": "Day",
      "days": "Day(s)",
      "weeks": "Week(s)",
      "months": "Month(s)",
      "years": "Year(s)",
      "every": "every",
      "summaryTimes": "time(s)",
      "summaryOn": "on",
      "summaryUntil": "until",
      "summaryRepeat": "Repeats",
      "summaryDay": "day(s)",
      "summaryWeek": "week(s)",
      "summaryMonth": "month(s)",
      "summaryYear": "year(s)",
      "monthWeek": "Month Week",
      "monthPosition": "Month Position",
      "monthExpander": "Month Expander",
      "yearExpander": "Year Expander",
      "repeatInterval": "Repeat Interval"
    }
  }
});



@Component({
  selector: 'app-daotao-baivietedit', 
  templateUrl: './baivietedit.component.html',    
  providers: [Repository, MaskedDateTimeService,  
    ToolbarService, LinkService, ImageService, HtmlEditorService
  ]
})

export class baivieteditComponent implements OnInit {

  @Output() savect: EventEmitter<any> = new EventEmitter();

  @ViewChild('Dialog')
  public Dialog: DialogComponent;


  public width: string = '50%';
  public animationSettings: AnimationSettingsModel = { effect: 'None' };
  public target: string = '.control-section';

  data: any;  
  donviid: string = null;
  lopid: any = null;
  chudeid: any = null;
  id: any = null;
  loai: number = 0;//0,null: bai viet, 1: thông báo, 2 tin tức
  currentUser: any;

  baivietSelect: any = {
    TieuDe: null, Id: null, NoiDung: null, DonViId: null, ChuDeId: null, KeyWord: null,
    LopId: null, LuotLike: null, LuotDislike: null, TuKhoas: null, TraLois: null,KhoaHocId:null,Loai:null
  }
 

  constructor(private route: ActivatedRoute,private router: Router,public repo: Repository, private translateService: TranslateService, private tooldata: ToolDataService) {
   
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit() {
    //this.id = this.route.snapshot.params["id"];
    //this.lopid = this.route.snapshot.params["cid"];
    this.currentUser = localStorage.getItem('currentUser');
    let tttdata;
    if (this.currentUser) {
      tttdata = JSON.parse(localStorage.getItem('currentUser'));      
      this.donviid = tttdata.id_don_vi;
    }    
   

  }
  loadInit(id, lopid,chudeid) {   
    this.id = id;
    this.lopid = lopid;
    this.chudeid = chudeid;
    console.log(this.lopid);
    this.repo.postRequest("api/diendan/getbaiviet/", { id: this.id, status: 0 })
      .subscribe(response => {
        this.baivietSelect = response;
        console.log(this.baivietSelect);
      });
    setTimeout(() => { this.rteObj.toolbarModule.refreshToolbarOverflow(); }, 1000); 
  }
  loadInit2(id, lopid, chudeid,loaibv) {
    this.id = id;
    this.lopid = lopid;
    this.chudeid = chudeid;
    this.loai = loaibv;
    console.log(this.lopid);
    this.repo.postRequest("api/diendan/getbaiviet/", { id: this.id, status: 0 })
      .subscribe(response => {
        this.baivietSelect = response;
        console.log(this.baivietSelect);
      });
    setTimeout(() => { this.rteObj.toolbarModule.refreshToolbarOverflow(); }, 1000);
  }

  
  public savebaiviet() {
    console.log(this.baivietSelect);
    if (this.baivietSelect.TieuDe === null || this.baivietSelect.TieuDe === '') {
      swal('Cảnh báo!', "Bạn chưa nhập tiêu đề bài viết!!!", 'warning');
      return;
    }    
    this.baivietSelect.DonViId = this.donviid;
    this.baivietSelect.ChuDeId = this.chudeid;
    this.baivietSelect.LopId = this.lopid;
    this.baivietSelect.KhoaHocId = this.lopid;
    this.baivietSelect.Loai = this.loai;
    this.repo.postRequest("api/diendan/addorupdate", this.baivietSelect)
      .subscribe(response => {

        if (response.Status === "OK")
          this.savect.emit(this.baivietSelect);
        else
          swal('Cảnh báo!', response.Status, 'warning');
      });
  }

  /*--------------Editor------------------------*/
  @ViewChild('toolsRTE')
  public rteObj: RichTextEditorComponent;

  private hostUrl: string = '/';

  public tools: ToolbarModule = {
    type: 'MultiRow',
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript', '|',
      'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
      'Outdent', 'Indent', '|',
      'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
  };

  public fileManagerSettings: FileManagerSettingsModel = {
    enable: true,
    path: '',
    ajaxSettings: {
      url: this.hostUrl + 'FileManager/FileOperations',
      getImageUrl: this.hostUrl + 'FileManager/GetImage',
      uploadUrl: this.hostUrl + 'FileManager/Upload',
      downloadUrl: this.hostUrl + 'FileManager/Download'
    }
  };

  public quickToolbarSettings: QuickToolbarSettingsModel = {
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };

  public maxLength = 20000;
  public textArea: HTMLElement;
  public myCodeMirror: any;
  public value: any;

  public handleFullScreen(e: any): void {
    const sbCntEle: HTMLElement = document.querySelector('.sb-content.e-view');
    const sbHdrEle: HTMLElement = document.querySelector('.sb-header.e-view');
    const leftBar: HTMLElement = document.querySelector('#left-sidebar');
    if (e.targetItem === 'Maximize') {
      if (Browser.isDevice && Browser.isIos) {
        addClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      addClass([leftBar], ['e-close']);
      removeClass([leftBar], ['e-open']);
    } else if (e.targetItem === 'Minimize') {
      if (Browser.isDevice && Browser.isIos) {
        removeClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      removeClass([leftBar], ['e-close']);
      if (!Browser.isDevice) {
        addClass([leftBar], ['e-open']);
      }
    }
  }

  public actionCompleteHandler(e: any): void {
    console.log("actiondsdsd");
    console.log(e);
    if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
     
    } else {
      setTimeout(() => { this.rteObj.toolbarModule.refreshToolbarOverflow(); }, 1000);
    }
  }


  public mirrorConversion(e?: any): void {
    const id: string = this.rteObj.getID() + 'mirror-view';
    let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
    const charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
    if (e.targetItem === 'Preview') {
      this.textArea.style.display = 'block';
      mirrorView.style.display = 'none';
      this.textArea.innerHTML = this.myCodeMirror.getValue();
      charCount.style.display = 'block';
    } else {
      if (!mirrorView) {
        mirrorView = createElement('div', { className: 'e-content' });
        mirrorView.id = id;
        this.textArea.parentNode.appendChild(mirrorView);
      } else {
        mirrorView.innerHTML = '';
      }
      this.textArea.style.display = 'none';
      mirrorView.style.display = 'block';
      this.renderCodeMirror(mirrorView, this.rteObj.value);
      charCount.style.display = 'none';
    }
  }

  public renderCodeMirror(mirrorView: HTMLElement, content: string): void {
    this.myCodeMirror = CodeMirror(mirrorView, {
      value: content,
      lineNumbers: true,
      mode: 'text/html',
      lineWrapping: true,

    });
  }
  
}
